import { render } from "./DashboardNotifications.vue?vue&type=template&id=7f522a16"
import script from "./DashboardNotifications.vue?vue&type=script&lang=js"
export * from "./DashboardNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__